<template>
  <div class="hidden-xs-only">
    <el-popover placement="bottom-end" trigger="click" @show="getReferences">
      <div class="dst-ref-button" slot="reference">
        <el-tooltip content="Show relations" placement="bottom">
          <el-button
            class="table-action-button icon-blue"
            icon="el-icon-edit-outline"
          >
          </el-button>
        </el-tooltip>
      </div>

      <div class="vxe-table card-base card-shadow--medium" style="height: 350px;">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          resizable
          highlight-hover-row
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :columns="tableColumns"
          :loading="tableLoading"
        />
      </div>
    </el-popover>
  </div>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";

export default {
  name: "DestinationReferences",

  props: {
    tenantId: { required: true },
    type: { required: true },
    id: { required: true },
    clearState: { required: true }
  },

  data() {
    return {
      tableData: [],
      tableLoading: false,
      tableColumns: [
        {
          type: "seq",
          width: 35,
        },
        {
          field: "type",
          title: "Source Type",
          minWidth: 250,
          sortable: true
        },
        {
          field: "name",
          title: "Source Name",
          minWidth: 250,
          sortable: true
        },
        {
          field: "number",
          title: "Source Number",
          minWidth: 150,
          sortable: true
        }
      ]
    };
  },

  watch: {
    clearState(val) {
      if (val) {
        this.tableData = [];
        this.tableLoading = false;
      }
    }
  },

  methods: {
    getReferences() {
      if (this.tableData.length === 0) {
        this.tableLoading = true;
        feathersClient
          .service("destination-references")
          .find({
            query: {
              tenantId: this.tenantId,
              type: this.type,
              id: this.id
            }
          })
          .then(res => {
            this.tableData = [...res];
            this.tableLoading = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dst-ref-button {
  position: fixed;
  top: 80px;
  right: 65px;
}
</style>
